import { Navigate } from "react-router";
import type { AppRouteGuard } from "../types";
import { useAuthenticated } from "./AuthenticatedRouteGuard";

export const AdminRouteGuard: AppRouteGuard = (props) => {
  const { user } = useAuthenticated();

  if (user.role !== "admin") {
    return <Navigate to="/" />;
  }

  return props.children;
};
